/* QGC Future: Offers bar + Offers & announcements behaviour.
   - Works out which offers this shopper should see (Trade / Retail switch, state picker, start and end dates).
   - Turns the 3D prism in the top bar and the 3D card stack together, one offer at a time.
   - Pauses on hover, keyboard focus, the pause button, a hidden tab, or when both are scrolled out of view.
   - Countdown, copy-code, card tilt, swipe and the drop-down card on pages without the stack.
   - Theme editor: rebuilds itself whenever an offer is added, changed, reordered or removed, and jumps to the offer
     you click in the sidebar (it stays there until you click away). */
(function(){
  'use strict';
  if(window.__qgcOffers) return; window.__qgcOffers = 1;
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  var html = document.documentElement;
  var live = null;   // the running instance

  /* things every instance shares */
  function mode(){ return html.getAttribute('data-qgc-mode') === 'commercial' ? 'trade' : 'retail'; }
  function state(){ try{ return (localStorage.getItem('qgc_trade_state') || '').toUpperCase(); }catch(e){ return ''; } }
  function fits(el){
    var now = Date.now()/1000;
    if(now < +el.getAttribute('data-start') || now > +el.getAttribute('data-end')) return false;
    var a = el.getAttribute('data-aud') || 'all';
    if(a !== 'all' && a !== mode()) return false;
    var s = el.getAttribute('data-states');
    if(s){ var my = state(); if(my && s.split(',').indexOf(my) === -1) return false; }
    return true;
  }
  function idOf(el){ return el.getAttribute('data-of-i'); }
  function byId(arr, id){ for(var i = 0; i < arr.length; i++) if(idOf(arr[i]) === id) return arr[i]; return null; }
  function pad(n){ return n < 10 ? '0' + n : '' + n; }

  function start(){
    var root = document.getElementById('fxOffers');
    var tpl = document.getElementById('fxOfCards');
    if(!root || !tpl) return null;

    var ac = new AbortController(), sig = { signal: ac.signal }, sigP = { signal: ac.signal, passive: true };
    var timers = [], observers = [];
    function on(el, ev, fn, opt){ if(el) el.addEventListener(ev, fn, opt || sig); }

    var AUTO = Math.max(3, parseFloat(root.getAttribute('data-auto')) || 6) * 1000;
    var faces = [].slice.call(root.querySelectorAll('.fx-of-face'));
    var stage = document.getElementById('fxOfStage');
    var deck = stage && stage.querySelector('.fx-of-deck');
    var cards = deck ? [].slice.call(deck.querySelectorAll('.fx-of-card')) : [];
    var dotsBox = stage && stage.querySelector('.fx-of-dots');
    var pop = document.getElementById('fxOfPop');
    var moreBtn = root.querySelector('.fx-of-more');
    var pauseBtn = root.querySelector('.fx-of-pause');
    root.classList.toggle('has-stage', !!stage);

    var list = [], k = 0;
    var timer = 0, paused = RM, hovering = 0, focused = false, onScreen = true, pinned = false;
    if(pauseBtn) paused = paused || pauseBtn.getAttribute('aria-pressed') === 'true';

    function refresh(){
      var was = list[k];
      list = faces.filter(fits).map(idOf);
      faces.forEach(function(f){ f.classList.toggle('is-off', list.indexOf(idOf(f)) === -1); });
      cards.forEach(function(c){ c.classList.toggle('is-off', list.indexOf(idOf(c)) === -1); });
      var none = !list.length;
      root.style.display = none ? 'none' : '';
      if(stage) stage.closest('.fx-of-stage-wrap').style.display = none ? 'none' : '';
      if(none){ stop(); return; }
      var nk = list.indexOf(was); k = nk === -1 ? 0 : nk;
      root.classList.toggle('is-one', list.length < 2);
      if(stage) stage.classList.toggle('is-one', list.length < 2);
      buildDots();
      show(0, true);
      if(pop && pop.classList.contains('is-open')) fillPop();
      plan();
    }

    /* ---------- bar prism ---------- */
    function turnBar(dir, instant){
      var id = list[k];
      faces.forEach(function(f){
        var cur = idOf(f) === id, had = f.classList.contains('is-cur');
        if(cur && !had){
          f.classList.add('no-tr'); f.classList.remove('is-up', 'from-up');
          if(dir < 0) f.classList.add('from-up');  // going back: the previous offer drops in from above
          void f.offsetWidth;
          f.classList.remove('no-tr', 'from-up');
          f.classList.add('is-cur');
          if(instant){ f.classList.add('no-tr'); void f.offsetWidth; f.classList.remove('no-tr'); }
        } else if(!cur && had){
          f.classList.remove('is-cur');
          if(dir >= 0) f.classList.add('is-up'); else f.classList.remove('is-up');
        }
        if(cur) f.removeAttribute('tabindex'); else f.setAttribute('tabindex', '-1');
        f.setAttribute('aria-hidden', cur ? 'false' : 'true');
      });
    }

    /* ---------- card stack ---------- */
    function stack(dir, instant){
      if(!cards.length) return;
      var n = list.length, prevFront = deck.querySelector('.fx-of-card.is-front');
      cards.forEach(function(c){
        var p = list.indexOf(idOf(c));
        if(p === -1){ c.classList.remove('is-front'); c.removeAttribute('data-pos'); return; }
        var o = (p - k + n) % n;
        c.setAttribute('data-pos', o === 0 ? '0' : o === 1 ? '1' : o === 2 ? '2' : 'h');
        var front = o === 0;
        c.classList.toggle('is-front', front);
        c.setAttribute('aria-hidden', front ? 'false' : 'true');
        if('inert' in c) c.inert = !front;
      });
      var nowFront = deck.querySelector('.fx-of-card.is-front');
      if(!instant && !RM && n > 1 && prevFront && nowFront && prevFront !== nowFront){
        var anim = dir >= 0 ? prevFront : nowFront;   // next: the front card flies off; back: the card flies in
        var cls = dir >= 0 ? 'is-leaving' : 'is-arriving';
        anim.classList.remove('is-leaving', 'is-arriving'); void anim.offsetWidth; anim.classList.add(cls);
        timers.push(setTimeout(function(){ anim.classList.remove(cls); }, 1000));
      }
      if(nowFront && !RM){ nowFront.classList.remove('shine'); void nowFront.offsetWidth; nowFront.classList.add('shine'); }
      if(prevFront && prevFront !== nowFront) resetTilt(prevFront);
      if(dotsBox) [].forEach.call(dotsBox.children, function(d, i){ d.setAttribute('aria-selected', i === k ? 'true' : 'false'); d.tabIndex = i === k ? 0 : -1; });
      tickNow();
    }

    function buildDots(){
      if(!dotsBox) return;
      dotsBox.innerHTML = '';
      list.forEach(function(id, i){
        var c = byId(cards, id), t = c && c.querySelector('.fx-of-title');
        var b = document.createElement('button');
        b.type = 'button'; b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Offer ' + (i + 1) + (t ? ': ' + t.textContent.trim() : ''));
        b.addEventListener('click', function(){ go(i - k); });
        dotsBox.appendChild(b);
      });
    }

    function show(dir, instant){ turnBar(dir, instant); stack(dir, instant); fitMsg(); }

    /* a message too long for the bar gets a slow slide so it can be read in full */
    function fitMsg(){
      var f = faces.filter(function(x){ return x.classList.contains('is-cur'); })[0]; if(!f) return;
      var box = f.querySelector('.fx-of-msg'), t = box && box.firstElementChild; if(!t) return;
      var over = t.scrollWidth - box.clientWidth;
      f.classList.toggle('is-long', over > 4);
      if(over > 4){ f.style.setProperty('--of-scroll', -(over + 16) + 'px'); f.style.setProperty('--of-tk', Math.max(5, Math.min(12, over/28 + 4)).toFixed(1) + 's'); }
    }
    var fT = 0; on(window, 'resize', function(){ clearTimeout(fT); fT = setTimeout(fitMsg, 150); }, sigP);

    function go(step){
      if(list.length < 2 || !step) return;
      k = (k + step + list.length * 4) % list.length;
      show(step > 0 ? 1 : -1, false);
      if(pop && pop.classList.contains('is-open')) fillPop();
      plan();
    }
    function goTo(id){
      var p = list.indexOf(id); if(p === -1 || p === k) return;
      var step = p - k; go(step);
    }

    /* ---------- autoplay ---------- */
    function canRun(){ return !paused && !pinned && !hovering && !focused && onScreen && !document.hidden && list.length > 1; }
    function plan(){ clearTimeout(timer); if(canRun()) timer = setTimeout(function(){ go(1); }, AUTO); }
    function stop(){ clearTimeout(timer); }
    function syncPause(){
      if(!pauseBtn) return;
      pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      pauseBtn.setAttribute('aria-label', paused ? 'Play offers' : 'Pause offers');
    }
    syncPause();
    on(pauseBtn, 'click', function(){ paused = !paused; syncPause(); plan(); });
    function watchHover(el){
      if(!el) return;
      on(el, 'pointerenter', function(e){ if(e.pointerType === 'mouse'){ hovering++; stop(); } });
      on(el, 'pointerleave', function(e){ if(e.pointerType === 'mouse'){ hovering = Math.max(0, hovering - 1); plan(); } });
      on(el, 'focusin', function(){ focused = true; stop(); });
      on(el, 'focusout', function(e){ if(!el.contains(e.relatedTarget)){ focused = false; plan(); } });
    }
    watchHover(root); watchHover(stage);
    on(document, 'visibilitychange', function(){ if(!document.hidden) refresh(); else stop(); });

    /* only turn while the bar or the stack can be seen */
    var seen = new Map();
    if(window.IntersectionObserver){
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){ seen.set(e.target, e.isIntersecting); });
        var any = false; seen.forEach(function(v){ if(v) any = true; });
        onScreen = any;
        if(stage) cards.forEach(function(c){ c.classList.toggle('is-vis', !!seen.get(stage)); });
        if(any) plan(); else stop();
        tickNow();
      });
      io.observe(root.querySelector('.fx-of-bar'));
      if(stage) io.observe(stage);
      observers.push(io);
    } else cards.forEach(function(c){ c.classList.add('is-vis'); });

    /* ---------- controls ---------- */
    function wireNav(box){
      if(!box) return;
      [].forEach.call(box.querySelectorAll('[data-of-step]'), function(b){
        on(b, 'click', function(){ go(+b.getAttribute('data-of-step')); });
      });
    }
    wireNav(root.querySelector('.fx-of-bar')); wireNav(stage);
    if(stage){
      on(stage, 'keydown', function(e){
        if(e.key === 'ArrowRight'){ go(1); e.preventDefault(); }
        else if(e.key === 'ArrowLeft'){ go(-1); e.preventDefault(); }
        if(dotsBox && dotsBox.contains(document.activeElement) && dotsBox.children[k]) dotsBox.children[k].focus();
      });
    }
    /* swipe: the stack and the bar */
    function swipe(el){
      if(!el) return;
      var x0 = null, y0 = 0, t0 = 0, swiped = 0;
      on(el, 'pointerdown', function(e){ if(e.pointerType === 'mouse' && e.button !== 0) return; x0 = e.clientX; y0 = e.clientY; t0 = Date.now(); }, sigP);
      on(el, 'pointerup', function(e){
        if(x0 === null) return;
        var dx = e.clientX - x0, dy = e.clientY - y0; x0 = null;
        if(Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy) * 1.4 && Date.now() - t0 < 900){ go(dx < 0 ? 1 : -1); swiped = Date.now(); }
      }, sigP);
      on(el, 'pointercancel', function(){ x0 = null; });
      /* a swipe should not also open the link under the finger */
      on(el, 'click', function(e){ if(swiped && Date.now() - swiped < 400){ e.preventDefault(); e.stopPropagation(); } }, { signal: ac.signal, capture: true });
    }
    swipe(deck); swipe(root.querySelector('.fx-of-prism'));

    /* ---------- tilt the front card toward the mouse ---------- */
    var tRaf = 0, tE = null;
    function resetTilt(c){ var i = c && c.querySelector('.fx-of-card-in'); if(i){ i.style.removeProperty('--of-tx'); i.style.removeProperty('--of-ty'); } }
    if(deck && FINE && !RM){
      on(deck, 'pointermove', function(e){
        tE = e; if(tRaf) return;
        tRaf = requestAnimationFrame(function(){
          tRaf = 0;
          var c = deck.querySelector('.fx-of-card.is-front .fx-of-card-in'); if(!c || !tE) return;
          var r = c.getBoundingClientRect();
          var nx = (tE.clientX - r.left)/r.width - .5, ny = (tE.clientY - r.top)/r.height - .5;
          c.style.setProperty('--of-tx', (-ny*7).toFixed(2) + 'deg');
          c.style.setProperty('--of-ty', (nx*9).toFixed(2) + 'deg');
        });
      }, sigP);
      on(deck, 'pointerleave', function(){ resetTilt(deck.querySelector('.fx-of-card.is-front')); });
    }

    /* ---------- countdown ---------- */
    var cdTimer = 0;
    function paintCd(cd){
      var left = Math.max(0, Math.floor(+cd.getAttribute('data-end') - Date.now()/1000));
      if(left <= 0){ refresh(); return; }
      var v = { d: Math.floor(left/86400), h: Math.floor(left%86400/3600), m: Math.floor(left%3600/60), s: left%60 };
      [].forEach.call(cd.querySelectorAll('b[data-u]'), function(b){
        var t = pad(v[b.getAttribute('data-u')]);
        if(b.textContent !== t){
          b.textContent = t;
          if(!RM && cd.__painted){ b.classList.remove('tick'); void b.offsetWidth; b.classList.add('tick'); }
        }
      });
      cd.__painted = true;
    }
    function activeCds(){
      var out = [];
      var f = deck && deck.querySelector('.fx-of-card.is-front .fx-of-cd');
      if(f && onScreen && seen.get(stage) !== false) out.push(f);
      var p = pop && pop.classList.contains('is-open') && pop.querySelector('.fx-of-cd');
      if(p) out.push(p);
      return out;
    }
    function tickNow(){
      clearTimeout(cdTimer);
      var cds = activeCds(); if(!cds.length || document.hidden) return;
      cds.forEach(paintCd);
      cdTimer = setTimeout(tickNow, 1000 - Date.now() % 1000 + 5);
    }
    /* fill every countdown once so the numbers are right before anyone looks */
    [].forEach.call(document.querySelectorAll('.fx-of-cd'), function(cd){ paintCd(cd); cd.__painted = false; });

    /* ---------- drop-down card (pages without the stack) ---------- */
    function fillPop(){
      if(!pop) return;
      var src = byId([].slice.call(tpl.content.querySelectorAll('.fx-of-card')), list[k]);
      pop.innerHTML = '';
      if(!src) return;
      var c = src.cloneNode(true);
      /* the card belongs to the other section, so it must not carry the editor's block markers */
      c.removeAttribute('data-shopify-editor-block');
      c.classList.add('is-front', 'is-vis');
      var img = c.querySelector('img'); if(img) img.loading = 'eager';
      var cd = c.querySelector('.fx-of-cd'); if(cd) paintCd(cd);
      pop.appendChild(c);
      tickNow();
    }
    function setPop(open){
      if(!pop || !moreBtn) return;
      if(open){
        fillPop();
        root.classList.add('is-pop-open');
        pop.hidden = false; void pop.offsetWidth;
        pop.classList.add('is-open');
        moreBtn.setAttribute('aria-expanded', 'true'); moreBtn.setAttribute('aria-label', 'Hide offer details');
        pinned = true; plan();
      } else {
        pop.classList.remove('is-open');
        moreBtn.setAttribute('aria-expanded', 'false'); moreBtn.setAttribute('aria-label', 'Show offer details');
        timers.push(setTimeout(function(){ if(!pop.classList.contains('is-open')){ pop.hidden = true; root.classList.remove('is-pop-open'); } }, 700));
        pinned = false; plan();
        tickNow();
      }
    }
    if(moreBtn && pop && !stage){
      on(moreBtn, 'click', function(){ setPop(!pop.classList.contains('is-open')); });
      on(document, 'keydown', function(e){ if(e.key === 'Escape' && pop.classList.contains('is-open')){ setPop(false); moreBtn.focus(); } });
      on(document, 'pointerdown', function(e){ if(pop.classList.contains('is-open') && !root.contains(e.target)) setPop(false); });
    }

    /* ---------- follow the Trade / Retail switch and the state picker ---------- */
    if(window.MutationObserver){
      var mo = new MutationObserver(refresh); mo.observe(html, { attributes: true, attributeFilter: ['data-qgc-mode'] }); observers.push(mo);
    }
    on(document, 'qgc:modeChanged', refresh);
    on(document, 'qgc:stateChanged', refresh);
    on(window, 'storage', function(e){ if(e.key === 'qgc_trade_state' || e.key === 'qgc_mode') refresh(); });
    /* an offer can end while the page is open */
    var minute = setInterval(function(){ if(!document.hidden){ var now = faces.filter(fits).map(idOf).join(); if(now !== list.join()) refresh(); } }, 60000);

    refresh();

    return {
      /* theme editor: show the offer whose block is selected, and hold it there */
      select: function(blockId){
        var c = null;
        [].concat(cards, [].slice.call(tpl.content.querySelectorAll('.fx-of-card'))).some(function(x){ if(x.getAttribute('data-block') === blockId){ c = x; return true; } });
        if(!c) return;
        pinned = true; stop();
        goTo(idOf(c));
        if(stage && stage.scrollIntoView) stage.scrollIntoView({ block: 'nearest', behavior: RM ? 'auto' : 'smooth' });
        else if(moreBtn && pop && !pop.classList.contains('is-open')) setPop(true);
      },
      release: function(){ pinned = false; plan(); },
      stop: function(){
        ac.abort(); clearTimeout(timer); clearTimeout(cdTimer); clearInterval(minute);
        timers.forEach(clearTimeout); observers.forEach(function(o){ o.disconnect(); });
      }
    };
  }

  /* ---------- copy code (one listener for the page) ---------- */
  function copyText(t){
    if(navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(t);
    return new Promise(function(res, rej){
      var a = document.createElement('textarea'); a.value = t; a.setAttribute('readonly', ''); a.style.cssText = 'position:fixed;opacity:0;';
      document.body.appendChild(a); a.select();
      try{ document.execCommand('copy') ? res() : rej(); }catch(e){ rej(e); }
      a.remove();
    });
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('.fx-of-code'); if(!b) return;
    var code = b.getAttribute('data-code');
    copyText(code).then(function(){
      b.classList.add('is-copied'); b.setAttribute('aria-label', 'Code ' + code + ' copied');
      clearTimeout(b.__t); b.__t = setTimeout(function(){ b.classList.remove('is-copied'); b.setAttribute('aria-label', 'Copy discount code ' + code); }, 2200);
    }, function(){});
  });

  function boot(){ if(live) live.stop(); live = start(); }
  /* the theme editor redraws a section after every change: copy the cards in again and restart */
  function isOurs(e){
    var t = e.target;
    return t && t.querySelector && (t.querySelector('#fxOffers') || t.querySelector('#fxOfCards') || t.id === 'fxOffers');
  }
  document.addEventListener('shopify:section:load', function(e){
    if(!isOurs(e)) return;
    if(window.qgcOfMount) window.qgcOfMount();
    boot();
  });
  document.addEventListener('shopify:section:unload', function(e){
    if(!isOurs(e)) return;
    setTimeout(function(){ if(window.qgcOfMount) window.qgcOfMount(); boot(); }, 0);
  });
  document.addEventListener('shopify:section:reorder', function(){ if(window.qgcOfMount) window.qgcOfMount(); boot(); });
  document.addEventListener('shopify:block:select', function(e){ if(live && e.detail && e.detail.blockId) live.select(e.detail.blockId); });
  document.addEventListener('shopify:block:deselect', function(){ if(live) live.release(); });

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
